// ============================================================
// Booking Hub — Shared Constants
// ============================================================

// Booking Status (Lifecycle)
export const BOOKING_STATUSES = [
  'Anfrage',
  'Angebot',
  'Bestätigt',
  'Rechnung offen',
  'Bezahlt',
  'Abgeschlossen',
  'Storniert',
  'Verschoben',
] as const;

export type BookingStatus = (typeof BOOKING_STATUSES)[number];

// Status → Google Calendar colorId
export const STATUS_CALENDAR_COLORS: Record<BookingStatus, string> = {
  'Anfrage': '5',
  'Angebot': '6',
  'Bestätigt': '2',
  'Rechnung offen': '4',
  'Bezahlt': '2',
  'Abgeschlossen': '8',
  'Storniert': '11',
  'Verschoben': '1',
};

// Status → Emoji
export const STATUS_EMOJIS: Record<BookingStatus, string> = {
  'Anfrage': '📥',
  'Angebot': '📤',
  'Bestätigt': '✅',
  'Rechnung offen': '💰',
  'Bezahlt': '💚',
  'Abgeschlossen': '✔️',
  'Storniert': '❌',
  'Verschoben': '🔄',
};

// Booking Art (Event-Typ)
// 3 Kern-Kategorien:
// - Workshop: Raummiete (egal ob halbtags/ganztags, Meeting, Offsite, Seminar, etc.)
// - Cocktailkurs: Separate Kurse mit eigenem Format
// - Produktion: Podcast, TV, Film, Foto etc.
export const BOOKING_ARTS = [
  'Workshop',
  'Cocktailkurs',
  'Produktion',
] as const;

export type BookingArt = (typeof BOOKING_ARTS)[number];

// Art → Frontend Color
export const ART_COLORS: Record<BookingArt, string> = {
  'Workshop': '#4CAF50',
  'Cocktailkurs': '#E91E63',
  'Produktion': '#FF5722',
};

// Attention Levels (Alert System)
export const ATTENTION_LEVELS = ['critical', 'warning', 'info', 'low'] as const;
export type AttentionLevel = (typeof ATTENTION_LEVELS)[number];

export const ATTENTION_EMOJIS: Record<AttentionLevel, string> = {
  'critical': '🔴',
  'warning': '🟠',
  'info': '🟡',
  'low': '🔵',
};

// History Sources
export const HISTORY_SOURCES = [
  'manual',
  'manual-override',
  'email-intake',
  'sent-monitor',
  'lexoffice',
  'ai',
  'telegram-chat',
] as const;
export type HistorySource = (typeof HISTORY_SOURCES)[number];

// Responsible Person Logic
// Marie: Cocktailkurs (eigenes Format)
// Pierre: Workshop + Produktion
// null/unknown: beide werden benachrichtigt
export const MARIE_ARTS: readonly BookingArt[] = ['Cocktailkurs'] as const;

// Zeitblock
export const ZEITBLOCKS = [
  'Ganzer Tag',
  'Halber Tag Vormittag',
  'Halber Tag Nachmittag',
  'Abendveranstaltung',
  'Vormittag',
  'Nachmittag',
  'Abend',
] as const;

export type Zeitblock = (typeof ZEITBLOCKS)[number];

// Bestuhlung
export const BESTUHLUNG_OPTIONS = [
  'Konferenz',
  'Stuhlkreis',
  'Theater',
  'U-Form',
  'Freie Bestuhlung',
] as const;

export type Bestuhlung = (typeof BESTUHLUNG_OPTIONS)[number];

// Quellen (Booking-Source)
export const QUELLEN = [
  'Globoform',
  'Spacebase',
  'Raumperle',
  'E-Mail',
  'Telefon',
  'Website',
  'Sonstige',
] as const;

export type Quelle = (typeof QUELLEN)[number];

// Email Classification
export const EMAIL_CLASSIFICATIONS = [
  'booking',
  'angebot',
  'ab',
  'rechnung',
  'stornierung',
  'follow-up',
  'irrelevant',
] as const;

export type EmailClassification = (typeof EMAIL_CLASSIFICATIONS)[number];

// Email Direction
export const EMAIL_DIRECTIONS = ['inbox', 'sent'] as const;
export type EmailDirection = (typeof EMAIL_DIRECTIONS)[number];

// Chat Roles
export const CHAT_ROLES = ['user', 'assistant', 'system'] as const;
export type ChatRole = (typeof CHAT_ROLES)[number];
